import { emptySplitApi } from "../../../components/apis/emptyApi";

export const baseApi = emptySplitApi;
